export const isLongTitle = title => {
    if (title) {
        return title.length >= 80;
    }
};

export const isLongText = (text, length) => {
    if (text !== undefined) {
        const isLong = text.length > length ? true : false;
        return isLong;
    }
};



// WEBPACK FOOTER //
// ./src/components/Shared/commonFunctions.js